/* eslint-disable no-restricted-imports */
import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress } from '../../../../Fct/generics/FctParams';
import { compoundTokens } from '../constants';
export var ExitMarket = createPlugin({
    protocol: 'COMPOUND_V2',
    type: 'ACTION',
    method: 'exitMarket',
    description: 'Borrow ETH or ERC20 tokens',
    supportedContracts: [
        { chainId: 1, address: '0x3d9819210A31b4961b30EF54bE2aeD79B9c9Cd3B' },
    ],
    getParams: function (_a) {
        var chainId = _a.chainId;
        return ({
            input: {
                to: new FctAddress({ destination: 'comptroller' }),
                methodParams: {
                    cToken: new FctAddress({
                        destination: 'ctoken',
                        options: compoundTokens.filter(function (token) { return token.chainId === Number(chainId); }),
                    }),
                },
            },
            output: {},
        });
    },
    initParams: {
        to: '0x3d9819210A31b4961b30EF54bE2aeD79B9c9Cd3B',
    },
});
